/*--------------------------------------
                  FILTERS
 --------------------------------------*/
filters = {
    init: function () {
        var $gridEl = $('.collection__grid');
        if (!$gridEl.length) return;

        var $grid = $gridEl.isotope({
            itemSelector: '.product-card',
            percentPosition: true,
            layoutMode: 'masonry',
            masonry: {
                columnWidth: '.product-card',
                gutter: window.innerWidth <= 991 ? 0 : 20,
            },
        });

        function relayout() {
            $grid.isotope('layout');
        }

        $gridEl.find('img').on('load', relayout);
        $(window).on('load', relayout);

        $(window).on('resize', function () {
            $grid.isotope({
                masonry: {
                    columnWidth: '.product-card',
                    gutter: window.innerWidth <= 991 ? 0 : 20,
                },
            });
        });

        $('.collection-filter').on('click', function () {
            var $btn = $(this);
            var isActive = $btn.hasClass('active');

            $('.collection-filter').removeClass('active');

            if (isActive) {
                $grid.isotope({ filter: '*' });
                return;
            }

            $btn.addClass('active');
            $grid.isotope({ filter: '.' + $btn.data('key') });
        });
    },
};

$(document).ready(function () {
    filters.init();
});
